import { useSelector } from "react-redux";
import {
  selectSelectedMatches
} from "../store/matchesSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DoublesPointsList from "./DoublesPointsList";
import {
  selectMatchesPointList,
  selectSelectedPointsIds,
  selectFilteredMatches,
  setMatchList,
  setNavigateToPoint,
  setSelectedPointsIds,
  getFilteredMatches,
} from "../store/videoPlayerSlice";
import { useLoadCompletedMatchPointsQuery } from "../../api/completeMatchesSlice";
import Spinner from "../../../UI/Spinner";
import CustomClipModal from "./CustomClipModal";
import classes from "./PointSelection.module.css";

const DoublesPointSelection = (props) => {
  const selectedMatches = useSelector(selectSelectedMatches);
  const selectedPointsIds = useSelector(selectSelectedPointsIds);
  const matchesPointList = useSelector(selectMatchesPointList);
  const filteredMatches = useSelector(selectFilteredMatches);

  const [isFiltering, setIsFiltering] = useState(false);
  const [isCustomClipModalOpen, setIsCustomClipModalOpen] = useState(false);
  let selectedMatchIds = selectedMatches.map((m) => m.matchInstanceId);

  const dispatch = useDispatch();
  const { data, isLoading, error, status, isFetching } = useLoadCompletedMatchPointsQuery(selectedMatchIds);

  useEffect(() => {
    if (data) {
      setIsFiltering(true);
      setTimeout(() => {
        let matchList = selectedMatches.map((match) => {
          return {
            ...match,
            pointList: data[match.matchInstanceId] ?? [],
          };
        });

        setIsFiltering(false);
        dispatch(setMatchList(matchList));
      }, 0);
    }
  }, [data]);


  const selectAllPointsHandler = () => {
    const filteredMatches = getFilteredMatches(matchesPointList, 0, 0);
    const selectedPoints = filteredMatches.flatMap((match) =>
      match.pointList.map((point) => point.pointId)
    );
    dispatch(setSelectedPointsIds(selectedPoints));
  }

  const unselectAllPointsHandler = () => {
    dispatch(setSelectedPointsIds([]));
  }

  let content = null;
  if (isLoading || isFetching || isFiltering) {
    content = (
      <div
        style={{ height: "65vh" }}
        className="card mt-1 mb-2  align-items-center justify-content-center"
      >
        <Spinner />
      </div>
    );
  } else if (error) {
    content = (
      <div
        style={{ height: "65vh" }}
        className="card mt-1 mb-2  align-items-center justify-content-center"
      >
        <h4>
          {" "}
          {status} {error.status} {JSON.stringify(error.error)}
        </h4>
      </div>
    );
  } else if (!matchesPointList || matchesPointList.length == 0) {
    content = (
      <div
        style={{ height: "65vh" }}
        className="card mt-1 mb-2  align-items-center justify-content-center"
      >
        <h4>No Match Is Selected</h4>
      </div>
    );
  } else {
    content = (
      <div className="card-body p-0 scrollbar perfect-scrollbar">
        {matchesPointList.map((match) => (
          <div key={match.matchId}>
            <DoublesPointsList match={match} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={{ height: "65vh" }} className="card mt-1 mb-2 ">
      {isCustomClipModalOpen && (
        <CustomClipModal onCloseModal={setIsCustomClipModalOpen} />
      )}
      <div className="card-header pl-2">
        <h5 className="mb-3">Points ({filteredMatches ? filteredMatches.reduce((sum, match) => sum + match.pointList.length, 0) : 0})</h5>
        <div className="flex-column d-flex">
          <div className="d-flex row flex-nowrap justify-content-between align-items-center mb-2 ml-0">
            <button
              className="btn btn-outline-warning btn-sm"
              type="button"
              data-toggle="modal"
              data-target="#customClipModal"
              disabled={filteredMatches?.length === 0}
              onClick={() => setIsCustomClipModalOpen(true)}
            >
              <strong>DOWNLOAD VIDEO</strong>
            </button>
            <button
              className="btn btn-falcon-default btn-sm"
              onClick={() => dispatch(setNavigateToPoint(true))}
            >
              Go To Active Point
            </button>
          </div>
          {matchesPointList?.length > 0 &&
            <div className="d-flex row mt-2 align-items-center ml-0">
              <button className={`btn btn-sm btn-light ${classes["point-select"]} mr-2`} onClick={selectAllPointsHandler} >Select All</button>
              <button className={`btn btn-sm btn-light ${classes["point-select"]} mr-2`} onClick={unselectAllPointsHandler} >Unselect All ({selectedPointsIds ? selectedPointsIds.length : 0})</button>
            </div>
          }
        </div>
      </div>
      {content}
    </div>
  );
};

export default DoublesPointSelection;
